/**
* DevExpress HTML/JS Reporting (designer\controls\spartlineTypes.js)
* Version:  24.1.7
* Build date: Oct 28, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
export const spartlineTypes = [
    { value: 'Line', displayValue: 'Line', localizationId: 'DevExpress.Sparkline.SparklineViewType.Line' },
    { value: 'Bar', displayValue: 'Bar', localizationId: 'DevExpress.Sparkline.SparklineViewType.Bar' },
    { value: 'WinLoss', displayValue: 'WinLoss', localizationId: 'DevExpress.Sparkline.SparklineViewType.WinLoss' },
    { value: 'Area', displayValue: 'Area', localizationId: 'DevExpress.Sparkline.SparklineViewType.Area' }
];
